import * as React from 'react';
import { RouteComponentProps } from 'react-router';

interface HelpState {
    helpCtxId: string;
}

//import Page from '../../wwwroot/help/usermanual.htm';
//var hlpHtml = require('../../wwwroot/help/usermanual.htm')
//
//import Page from '../../wwwroot/help/usermanual.htm';
//var htmlDoc = { __html: Page };

export class Help extends React.Component<RouteComponentProps<{}>, HelpState> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = { helpCtxId: '' };
    }
    //<iframe src='help/usermanual.htm' style={{ position: 'absolute', width: '100%', height: '100%', border: 'none', zIndex: 1, top:'50px', left: '50px' }} />
    //<h2>Помощь</h2>
    //style = {{ width: '100%', height: '800px', border: 'none' }}
    //<span>Справочная система</span>

    public render() {
        return <div className='otc-help'>
            <iframe src='help/usermanual.htm' />
        </div>;
    }
}
